/** Returns address object formatted like '123 Main St. Somewhere, NY 12345' */
export const formatAddress = (address) => {
    const line1 = address.line1 ?? '';
    const city = address.city ?? '';
    const state = address.state ?? '';
    const postalCode = address.postalCode ?? '';
    if (!line1 && !city && !state && !postalCode) {
        return '';
    }
    if (!line1 && !city) {
        return squeeze(`${state} ${postalCode}`);
    }
    if (!state && !postalCode) {
        return squeeze(`${line1} ${city}`);
    }
    return squeeze(`${line1} ${city}, ${state} ${postalCode}`);
};
/** Returns string without extra spaces */
function squeeze(str) {
    return str.replace(/\s+/g, ' ').trim();
}
